import type { SVGProps } from "react";

export function IconWhiteUmbrella(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path
        d="M16 50.3332C16 51.3838 16.2069 52.4241 16.609 53.3947C17.011 54.3653 17.6003 55.2472 18.3431 55.9901C19.086 56.733 19.9679 57.3222 20.9385 57.7243C21.9091 58.1263 22.9494 58.3332 24 58.3332C25.0506 58.3332 26.0909 58.1263 27.0615 57.7243C28.0321 57.3222 28.914 56.733 29.6569 55.9901C30.3997 55.2472 30.989 54.3653 31.391 53.3947C31.7931 52.4241 32 51.3838 32 50.3332L32 32M32 7C57 7 57 32 57 32L7 32C7 32 6.99996 7 32 7ZM32 7C34.9174 7 37.7153 9.63392 39.7782 14.3223C41.8411 19.0107 43 25.3696 43 32M32 7C29.0826 7 26.2847 9.63392 24.2218 14.3223C22.1589 19.0107 21 25.3696 21 32M9 23L55 23"
        stroke="#23232C"
        strokeWidth="1.5"
      />
      <path
        d="M32 7V4"
        stroke="#23232C"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
